import { render } from "./afterSaleQeustion.vue?vue&type=template&id=6e5df700"
import script from "./afterSaleQeustion.vue?vue&type=script&lang=js"
export * from "./afterSaleQeustion.vue?vue&type=script&lang=js"

import "./afterSaleQeustion.vue?vue&type=style&index=0&id=6e5df700&lang=css"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__